<div class="navbar-container">
    <div>
        <img class="logo" src="assets/images/logos/kenindia-logo.png" alt="Logo" [routerLink]="['/dashboard']" />
      
    </div>
    <h5 class="text-white d-inline menu-title">
        {{'travel_insurance' | translate}}
    </h5>
    <div class="menu-items">
        <!-- <button class="menu-item" (click)="Dashboard()">
            <div class="menu-icon" tabindex="0">
                <i class="fa fa-tachometer"></i>
            </div>
        </button>
        <button class="menu-item" tabindex="0">
            <div class="menu-icon">
                <i class="fas fa-bookmark"></i>
            </div>
        </button> -->
         <div class="dropdown" #dropdownButton1>
         <div class="language-dropdown">
<button class="dropdown-btn">
    <img [src]="currentLang === 'en' ? 'assets/images/en.jpg' : 'assets/images/fn.png'" [alt]="currentLang === 'en' ? 'English Flag' : 'French Flag'" class="flag-icon"> {{ currentLang === 'en' ? 'EN' : 'FR' }}
  </button>
  <div class="dropdown-content">
    <a href="#" *ngIf="currentLang === 'fr'" data-lang="en" (click)="changeLanguage('en'); $event.preventDefault()">
      <img src="assets/images/en.jpg" alt="English Flag" class="flag-icon"> EN
    </a>
    <a href="#" *ngIf="currentLang === 'en'" data-lang="fr" (click)="changeLanguage('fr'); $event.preventDefault()">
      <img src="assets/images/fn.png" alt="French Flag" class="flag-icon"> FR
    </a>
  </div>
</div>
         </div>
        <div class="dropdown" #dropdownButton1>
            <button class="menu-item" tabindex="0" data-toggle="dropdown" id="dropdownMenuButton1"
                data-bs-toggle="dropdown" aria-expanded="false">
                <div class="menu-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="5 0 30 40" fill="none">
                        <rect width="40" height="40" fill="" />
                        <path
                            d="M10 15H15V10H10V15ZM17.5 30H22.5V25H17.5V30ZM10 30H15V25H10V30ZM10 22.5H15V17.5H10V22.5ZM17.5 22.5H22.5V17.5H17.5V22.5ZM25 10V15H30V10H25ZM17.5 15H22.5V10H17.5V15ZM25 22.5H30V17.5H25V22.5ZM25 30H30V25H25V30Z"
                            fill="white" />
                    </svg>
                </div>
            </button>
            <div class="dropdown-menu" (click)="preventClose($event)" aria-labelledby="dropdownMenuButton1">
                <ng-container *ngIf="!subMenu && !activeMenu">

                    <div class="fcontainer">
                        <div class="fc">
                            <div class="mcontainer">
                                <div class="sub-container">
                                    <div class="text-container">
                                        <div class="text-title">My Modules</div>
                                    </div>
                                </div>
                                <div class="separator"></div>
                            </div>
                            <div class="row">
                                <div class="menuicon-container pointer col-md-4" *ngFor="let m of menuToView">
                                    <div class="mc" [matTooltip]="m.toolTip?m.toolTip:m.moduleName"
                                        [matTooltipPosition]="'above'"
                                        (click)="navigateToSubMenu('View',m.sWAModuleID, m.url, m, 'dropdownButton1', $event)">
                                        <div class="mc1">
                                            <i class="custom-icon {{m.iconClass}}"></i>
                                        </div>
                                    </div>
                                    <div class="mt">{{ m.moduleName }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="subMenu && !activeMenu">
                    <div class="fcontainer">
                        <div class="fc">
                            <div class="mcontainer">
                                <div class="sub-container">
                                    <div class="icon-container">
                                        <div class="icon">
                                            <em class="fa fa-chevron-circle-left"
                                                (click)="menuBack($event, 'subMenu');"></em>
                                        </div>
                                    </div>
                                    <div class="text-container">
                                        <div class="text-label">My Modules</div>
                                        <div class="text-title">{{mainModule?.moduleName}}</div>
                                    </div>
                                </div>
                                <div class="separator"></div>
                            </div>
                            <div class="row">
                                <div class="menuicon-container pointer col-md-4" *ngFor="let m of menuSubModules">
                                    <div class="mc" [matTooltip]="m.toolTip?m.toolTip:m.moduleName"
                                        [matTooltipPosition]="'above'"
                                        (click)="navigateToSubMenu(m.isFunctionality,m.sWAModuleID, m.url, m, 'dropdownButton1', $event)">
                                        <div class="mc-new">
                                            <i class="custom-icon {{m.iconClass}}"></i>
                                        </div>
                                    </div>
                                    <div class="mt">{{ m.moduleName }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!subMenu && activeMenu">
                    <div class="fcontainer">
                        <div class="fc">
                            <div class="mcontainer">
                                <div class="sub-container">
                                    <div class="icon-container">
                                        <div class="icon">
                                            <em class="fa fa-chevron-circle-left"
                                                (click)="menuBack($event, 'activeMenu');"></em>
                                        </div>
                                    </div>
                                    <div class="text-container">
                                        <div class="text-label">{{mainModule?.moduleName}}</div>
                                        <div class="text-title">{{subModule?.moduleName}}</div>
                                    </div>
                                </div>
                                <div class="separator"></div>
                            </div>
                            <div class="row">
                                <div class="menuicon-container pointer col-md-4" *ngFor="let m of activeModule">
                                    <div class="mc" [matTooltip]="m.toolTip?m.toolTip:m.moduleName"
                                        [matTooltipPosition]="'above'"
                                        (click)="navigateToSubMenu('View',m.sWAModuleID, m.url, m, 'dropdownButton1', $event)">
                                        <div class="mc-new">
                                            <i class="custom-icon {{m.iconClass}}"></i>
                                        </div>
                                    </div>
                                    <div class="mt">{{ m.moduleName }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>


        <!-- <button class="menu-item" tabindex="0">
            <div class="menu-icon">
                <i class="fa fa-life-ring"></i>
            </div>
        </button> -->

        <div class="dropdown" #dropdownButton>
            <button class="menu-item dropdown" tabindex="0" data-toggle="dropdown" id="dropdownMenuButton2"
                data-bs-toggle="dropdown" aria-expanded="false">
                <div class="menu-icon">
                    <i class="fas fa-user"></i>
                </div>
            </button>
            <div class="dropdown-menu profile-menu" (click)="preventClose($event)"
                aria-labelledby="dropdownMenuButton2">
                <ng-container>
                    <div class="profile-info p-2">
                        <div>
                            <span class="name">{{userDetail?.fullName?userDetail?.fullName:''}}</span><br>

                            <span class="mem-id" *ngIf="userDetail?.userUniqueID">{{'Member_ID'|translate}}: <strong>{{
                                    userDetail?.userUniqueID }}</strong></span>

                        </div>
                        <img src="assets/images/profiles/myprofile.png" alt="">
                    </div>
                    <ul class="profile-menu-list">
                        <li class="pointer" (click)="sendData() ">
                            <i class="fas fa-cog"></i>
                            {{'Settings' | translate}}
                        </li>
                        <!-- <li class="pointer" (click)="orgChart() ">
                            <i class="fas fa-sitemap"></i>
                            {{'organization' | translate}}
                        </li>
                       
                        <li [routerLink]="['/view/view-my-time-logs/59463268-D190-4D2B-B845-BBD1F790327F']"
                            class="pointer">
                            <i class="fas fa-clock"></i>
                            {{'time-log' | translate}}
                        </li>
                        <li [routerLink]="['/view/my-task/0A2BBD7B-DB88-4346-908E-07D255C4D9A7']" class="pointer">
                            <i class="fas fa-clock"></i>
                            {{'task' | translate}}
                        </li> -->
                        <li (click)="logout()" class="pointer">
                            <i class="fas fa-sign-out-alt"></i>
                            {{'LOGOUT' | translate}}
                        </li>
                    </ul>

                </ng-container>
            </div>

        </div>

    </div>
</div>